"use client";

import useTranslate from "@app/_hooks/useTranslate";

import RichText from "@blocks/RichText/RichText";
import { Heading, Paragraph } from "@components/ui";
import NewCustomerForm from "@forms/newCustomer";
import type { FormPageQuery } from "@server/gql/graphql";
import { useSearchParams } from "next/navigation";

export default function Wrapper({
  page,
  market,
  locale,
}: {
  page: FormPageQuery["page"];
  market: string;
  locale: string | undefined;
}) {
  const t = useTranslate();
  const searchParams = useSearchParams();
  if (!page) return null;
  const { title, subtitle, ingress } = page;
  const [heading = "", subheading = ""] = title?.split("?") ?? [];

  if (searchParams.has("success"))
    return (
      <Heading
        as="h1"
        size={4}
        className="max-w-content place-self-center self-center"
      >
        {t("newCustomerFormSuccessHeading")}
        <br />
        {t("newCustomerFormSuccessText")}
      </Heading>
    );
  return (
    <>
      <Heading as="h1" size={4} className="max-w-content">
        {heading}?<br />
        {subheading}
      </Heading>
      <Paragraph size="small" className="max-w-content">
        {subtitle}
      </Paragraph>
      <NewCustomerForm />
      {ingress && (
        <RichText
          className="text-sm text-gray-400"
          content={ingress}
          market={market}
          locale={locale}
        />
      )}
    </>
  );
}
